function Certifications() {
  return (
    <div className="h-full flex flex-col justify-center relative py-14">
      <h2 className="text-2xl md:text-3xl font-bold mb-5 text-black dark:text-white">
        Certifications
      </h2>
      <ul>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://drive.google.com/file/d/19iQ9yd8Coxh7YFUNjB7kBQKc_bv4GwIb/view"
              target="_blank"
              rel="noreferrer"
            >
              Sertifikat MSIB - Scalable Web Service With Golang (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/741eef9a-c296-4555-ad35-06cc73019e52"
              target="_blank"
              rel="noreferrer"
            >
              Golang Tingkat Lanjut (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/3f1776c0-8e94-4aa2-a3ff-6462eb2b9181"
              target="_blank"
              rel="noreferrer"
            >
              Mengetahui Penggunaan Database (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/f6489456-cfc8-4afe-808b-4eb7f646c171"
              target="_blank"
              rel="noreferrer"
            >
              REST API dengan Golang (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/7d50c5e9-a4bb-4948-a396-25f92944b045"
              target="_blank"
              rel="noreferrer"
            >
              Golang Tingkat Pemula (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://drive.google.com/file/d/1uRu3k3C4heS7F8NZYjyjg4gGuk0d40mM/view"
              target="_blank"
              rel="noreferrer"
            >
              Sertifikat MSIB - React & React Native for Front-End Developer
              (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/8c363f8d-01fe-4a7b-8784-8b956f9404cc"
              target="_blank"
              rel="noreferrer"
            >
              Fungsi dan Penggunaan React Native (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/d64faae3-1a65-4b43-a0b2-a5c4639e166d"
              target="_blank"
              rel="noreferrer"
            >
              Styling Komponen React (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://sertiva.id/credential/1f64fbb1-ce2e-4244-ad8d-ef0f50d82ffa"
              target="_blank"
              rel="noreferrer"
            >
              HTML dan CSS Dasar (MSIB 2023)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://www.dicoding.com/certificates/4EXGNEMKEZRL"
              target="_blank"
              rel="noreferrer"
            >
              Menjadi Front-End Web Developer Expert (IDCamp 2022)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://www.dicoding.com/certificates/JLX1L9645X72"
              target="_blank"
              rel="noreferrer"
            >
              Belajar Fundamental Front-End Web Development (IDCamp 2022)
            </a>
          </h3>
        </li>
        <li className="mb-3 flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://www.dicoding.com/certificates/1OP852341PQK"
              target="_blank"
              rel="noreferrer"
            >
              Belajar Membuat Front-End Web untuk Pemula (IDCamp 2022)
            </a>
          </h3>
        </li>
        <li className="flex items-center gap-x-3">
          <i class="bi bi-award-fill text-2xl text-[#4070F4]"></i>
          <h3 className="font-semibold text-base sm:text-sm md:text-lg text-slate-700 dark:text-slate-400 hover:underline">
            <a
              href="https://www.dicoding.com/certificates/1OP86M66QXQK"
              target="_blank"
              rel="noreferrer"
            >
              Belajar Dasar Pemrograman Web (IDCamp 2022)
            </a>
          </h3>
        </li>
      </ul>

      <div className="hidden md:flex flex-col gap-8 absolute right-0 top-0 bottom-0 justify-center">
        <a
          className="text-2xl lg:text-3xl text-[#374151] dark:text-white hover:text-[#4070F4] dark:hover:text-[#4070F4]"
          href="https://www.facebook.com/ekialfani"
          target="_blank"
          rel="noreferrer"
        >
          <i class="bi bi-facebook"></i>
        </a>
        <a
          className="text-2xl lg:text-3xl text-[#374151] dark:text-white hover:text-[#4070F4] dark:hover:text-[#4070F4]"
          href="https://www.instagram.com/ekialfni/"
          target="_blank"
          rel="noreferrer"
        >
          <i class="bi bi-instagram"></i>
        </a>
        <a
          className="text-2xl lg:text-3xl text-[#374151] dark:text-white hover:text-[#4070F4] dark:hover:text-[#4070F4]"
          href="https://www.linkedin.com/in/eki-alfani-1a1122271"
          target="_blank"
          rel="noreferrer"
        >
          <i class="bi bi-linkedin"></i>
        </a>
        <a
          className="text-2xl lg:text-3xl text-[#374151] dark:text-white hover:text-[#4070F4] dark:hover:text-[#4070F4]"
          href="https://github.com/ekialfani"
          target="_blank"
          rel="noreferrer"
        >
          <i class="bi bi-github"></i>
        </a>
      </div>
    </div>
  );
}

export default Certifications;
